import type { IPaginationDTO, IPaginationResponse } from '@/models/pagination.model';
import { IAddress } from '@/models/addresses.model';

/** Global bids list (aligned with aibo-frontend seller app). */
export enum BiddingEndpoints {
  BIDS_LIST = '/bids',
}

export enum BidEndpoints {
  ROOT = '/properties',
  BIDDERS_CONTEXT = '/bidders-context',
  BIDDERS = '/bidders',
  POWER_OF_ATTORNEY = '/power-of-attorney',
  BID = '/bid',
  BIDS = '/bids',
}

export const getBidEndpoints = ({ propertyId, bidId }: { propertyId?: string; bidId?: string }) => ({
  GET_BIDDERS_CONTEXT: `${BidEndpoints.ROOT}/${propertyId}${BidEndpoints.BIDDERS_CONTEXT}`,
  PUT_BIDDERS: `${BidEndpoints.ROOT}/${propertyId}${BidEndpoints.BIDDERS}`,
  PUT_POWER_OF_ATTORNEY: `${BidEndpoints.ROOT}/${propertyId}${BidEndpoints.POWER_OF_ATTORNEY}`,
  POST_BID: `${BidEndpoints.ROOT}/${propertyId}${BidEndpoints.BIDS}`,
  GET_BID_RESULT: `${BidEndpoints.BIDS}/${bidId}`,
  GET_BIDS_LIST: `${BidEndpoints.ROOT}/${propertyId}${BidEndpoints.BIDS}`,
});

export interface IBidder {
  PK: string;
  email: string;
  full_name: string;
  phone_number: string;
  address: IAddress;
  national_id: string;
}

export interface IFinancialAndBidDetails {
  bid_amount: number | null;
  expiry_date: string | null;
  expiry_time: string | null;
  preferred_takeover_date: string | null;
  reservation: string | null;
  bank_name: string | null;
  bank_contact_name: string | null;
  bank_contact_email: string | null;
  bank_contact_phone: string | null;
  is_guidelines_confirmed: boolean;
}

export enum BidStatus {
  WAITING_CONFIRMATION = 'waiting_confirmation',
  APPROVED = 'approved',
  CONFIRMED = 'confirmed',
  REJECTED = 'rejected',
  EXPIRED = 'expired',
}

export enum BidStatusEnum {
  WAITING_CONFIRMATION = 'waiting_confirmation',
  CONFIRMED = 'confirmed',
  ACCEPTED = 'accepted',
  EXPIRED = 'expired',
  REJECTED = 'rejected',
}

export interface IBidContext {
  PK: string;
  bidders: IBidder[];
  financial_and_bid_details: IFinancialAndBidDetails | null;
  status: BidStatusEnum;
}

export interface ICoBidder {
  id: string;
  full_name: string;
  email: string;
  phone_number: string;
  address: IAddress;
}

export interface IBidItem {
  id: string;
  bid_amount: number;
  bid_expires_at: string;
  preferred_takeover_date: string;
  reservation: string;
  is_alternative_financing?: boolean | null;
  alternative_financing_details?: string | null;
  bank_name: string;
  bank_contact_person: string;
  bank_contact_person_email: string;
  bank_contact_person_phone_number: string;
  status: BidStatusEnum;
  bidder_full_name: string;
  bidder_email: string;
  bidder_phone_number: string;
  bidder_address: IAddress;
  co_bidders?: ICoBidder[];
}

// ============== DTO ==============

export interface IGetBidsListDTO extends IPaginationDTO {
  propertyId: string;
  with_co_bidders?: boolean;
}

// ============== Response ==============

export interface IGetBidsListResponse {
  items: IBidItem[];
  items_count: number;
  cursor: IPaginationResponse;
  total?: number;
  page_size?: number;
}
